require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-when-loyalty-fails.json") })
        }
      }, "path---authors-when-loyalty-fails");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-when-loyalty-fails!./.cache/json/authors-when-loyalty-fails.json
// module id = 1360
// module chunks = 231608221292675